import css from 'styled-jsx/css'

import { colors, common, sizes } from '../../theme'


export default css`
  .container {
    height: ${sizes.footer.desktop.height};
    padding: 2rem;
    padding-left: 5rem;
    background: ${colors.midnightExpress};
  }

  .container :global(.inner) {
    display: flex;
    max-width: ${sizes.body.desktop.maxWidth};
    margin: 0 auto;
    width: 100%;
    align-items: flex-end;
    margin-bottom: 2rem;
  }

  .container :global(.blocks) {
    display: flex;
    flex: 1;
    align-items: center;
  }

  .container :global(.social-bar ul) {
    display: flex;
    gap: 2rem;
  }

  .container :global(.bottom) {
    display: flex;
    justify-content: space-between;
    margin-top: 2rem;
    max-width: ${sizes.body.desktop.maxWidth};
    margin: 0 auto;
  }

  .container :global(.bottom .links) {
    display: flex;
    gap: 2rem;
  }

  .container :global(.bottom .links *) {
    ${common.small}
    font-size: 1.2rem;
    color: ${colors.pureWhite};
    text-decoration: none;
  }

  .container :global(.certificate) {
    ${common.h7}
    text-transform: uppercase;
    color: ${colors.pureWhite};
  }

  .container :global(.certificate.mobile) {
    display: none;
  }

  .container :global(.social-bar .socialLabel) {
    ${common.h6}
  }

  @media screen and (max-width: ${sizes.media.tablet.maxWidth}) {
    .container {
      height: auto;
      padding: 5rem 0rem;
      flex-direction: column;
    }

    .container :global(.certificate.desktop) {
      display: none;
    }

    .container :global(.certificate.mobile) {
      width: 100%;
      padding: 0 2rem;
      display: block;
    }

    .container :global(.bottom) {
      padding: 0 2rem;
    }

    .container :global(.bottom .links) {
      flex: 1;
      justify-content: center;
      flex-wrap: wrap;
      gap: 2rem;
      border-top: 1px solid ${colors.pureWhite};
      padding-top: 3rem;
    }

    .container :global(.inner) {
      flex-direction: column;
      align-items: center;
      margin-bottom: 0;
    }

    .container :global(.social-bar) {
      align-items: center;
    }

    .container :global(.blocks) {
      flex: auto;
      flex-direction: column;
      align-self: stretch;
    }
  }
`
